module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.22465/js/img/productIcons/OperationsHub_Pro.svg"